export const initialApartments = {
  2: {
    floor: 2,
    building: 'A',
    apartmentNumber: 'A001',
    sceneName: 'scene_02krs_A001',
    sceneName_future: 'scene_02krs_A001_future',
    name: 'A001',
    label: 'A1',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      3: 'A010',
      4: 'A019',
      5: 'A028',
      6: 'A037',
      7: 'A046',
      8: 'A055',
      9: 'A064',
      10: 'A073',
      11: 'A082',
      12: 'A091',
      13: 'A100',
      14: 'A109',
      15: 'A118',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  3: {
    floor: 3,
    building: 'A',
    apartmentNumber: 'A010',
    sceneName: 'scene_03krs_A010',
    sceneName_future: 'scene_03krs_A010_future',
    name: 'A010',
    label: 'A10',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A001',
      4: 'A019',
      5: 'A028',
      6: 'A037',
      7: 'A046',
      8: 'A055',
      9: 'A064',
      10: 'A073',
      11: 'A082',
      12: 'A091',
      13: 'A100',
      14: 'A109',
      15: 'A118',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  4: {
    floor: 4,
    building: 'A',
    apartmentNumber: 'A019',
    sceneName: 'scene_04krs_A019',
    sceneName_future: 'scene_04krs_A019_future',
    name: 'A019',
    label: 'A19',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A001',
      3: 'A010',
      5: 'A028',
      6: 'A037',
      7: 'A046',
      8: 'A055',
      9: 'A064',
      10: 'A073',
      11: 'A082',
      12: 'A091',
      13: 'A100',
      14: 'A109',
      15: 'A118',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  5: {
    floor: 5,
    building: 'A',
    apartmentNumber: 'A028',
    sceneName: 'scene_05krs_A028',
    sceneName_future: 'scene_05krs_A028_future',
    name: 'A028',
    label: 'A28',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A001',
      3: 'A010',
      4: 'A019',
      6: 'A037',
      7: 'A046',
      8: 'A055',
      9: 'A064',
      10: 'A073',
      11: 'A082',
      12: 'A091',
      13: 'A100',
      14: 'A109',
      15: 'A118',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  6: {
    floor: 6,
    building: 'A',
    apartmentNumber: 'A037',
    sceneName: 'scene_06krs_A037',
    sceneName_future: 'scene_06krs_A037_future',
    name: 'A037',
    label: 'A37',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A001',
      3: 'A010',
      4: 'A019',
      5: 'A028',
      7: 'A046',
      8: 'A055',
      9: 'A064',
      10: 'A073',
      11: 'A082',
      12: 'A091',
      13: 'A100',
      14: 'A109',
      15: 'A118',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  7: {
    floor: 7,
    building: 'A',
    apartmentNumber: 'A046',
    sceneName: 'scene_07krs_A046',
    sceneName_future: 'scene_07krs_A046_future',
    name: 'A046',
    label: 'A46',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A001',
      3: 'A010',
      4: 'A019',
      5: 'A028',
      6: 'A037',
      8: 'A055',
      9: 'A064',
      10: 'A073',
      11: 'A082',
      12: 'A091',
      13: 'A100',
      14: 'A109',
      15: 'A118',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  8: {
    floor: 8,
    building: 'A',
    apartmentNumber: 'A055',
    sceneName: 'scene_08krs_A055',
    sceneName_future: 'scene_08krs_A055_future',
    name: 'A055',
    label: 'A55',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A001',
      3: 'A010',
      4: 'A019',
      5: 'A028',
      6: 'A037',
      7: 'A046',
      9: 'A064',
      10: 'A073',
      11: 'A082',
      12: 'A091',
      13: 'A100',
      14: 'A109',
      15: 'A118',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  9: {
    floor: 9,
    building: 'A',
    apartmentNumber: 'A064',
    sceneName: 'scene_09krs_A064',
    sceneName_future: 'scene_09krs_A064_future',
    name: 'A064',
    label: 'A64',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A001',
      3: 'A010',
      4: 'A019',
      5: 'A028',
      6: 'A037',
      7: 'A046',
      8: 'A055',
      10: 'A073',
      11: 'A082',
      12: 'A091',
      13: 'A100',
      14: 'A109',
      15: 'A118',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  10: {
    floor: 10,
    building: 'A',
    apartmentNumber: 'A073',
    sceneName: 'scene_10krs_A073',
    sceneName_future: 'scene_10krs_A073_future',
    name: 'A073',
    label: 'A73',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A001',
      3: 'A010',
      4: 'A019',
      5: 'A028',
      6: 'A037',
      7: 'A046',
      8: 'A055',
      9: 'A064',
      11: 'A082',
      12: 'A091',
      13: 'A100',
      14: 'A109',
      15: 'A118',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  11: {
    floor: 11,
    building: 'A',
    apartmentNumber: 'A082',
    sceneName: 'scene_11krs_A082',
    sceneName_future: 'scene_11krs_A082_future',
    name: 'A082',
    label: 'A82',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A001',
      3: 'A010',
      4: 'A019',
      5: 'A028',
      6: 'A037',
      7: 'A046',
      8: 'A055',
      9: 'A064',
      10: 'A073',
      12: 'A091',
      13: 'A100',
      14: 'A109',
      15: 'A118',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  12: {
    floor: 12,
    building: 'A',
    apartmentNumber: 'A091',
    sceneName: 'scene_12krs_A091',
    sceneName_future: 'scene_12krs_A091_future',
    name: 'A091',
    label: 'A91',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A001',
      3: 'A010',
      4: 'A019',
      5: 'A028',
      6: 'A037',
      7: 'A046',
      8: 'A055',
      9: 'A064',
      10: 'A073',
      11: 'A082',
      13: 'A100',
      14: 'A109',
      15: 'A118',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  13: {
    floor: 13,
    building: 'A',
    apartmentNumber: 'A100',
    sceneName: 'scene_13krs_A100',
    sceneName_future: 'scene_13krs_A100_future',
    name: 'A100',
    label: 'A100',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A001',
      3: 'A010',
      4: 'A019',
      5: 'A028',
      6: 'A037',
      7: 'A046',
      8: 'A055',
      9: 'A064',
      10: 'A073',
      11: 'A082',
      12: 'A091',
      14: 'A109',
      15: 'A118',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  14: {
    floor: 14,
    building: 'A',
    apartmentNumber: 'A109',
    sceneName: 'scene_14krs_A109',
    sceneName_future: 'scene_14krs_A109_future',
    name: 'A109',
    label: 'A109',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A001',
      3: 'A010',
      4: 'A019',
      5: 'A028',
      6: 'A037',
      7: 'A046',
      8: 'A055',
      9: 'A064',
      10: 'A073',
      11: 'A082',
      12: 'A091',
      13: 'A100',
      15: 'A118',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  15: {
    floor: 15,
    building: 'A',
    apartmentNumber: 'A118',
    sceneName: 'scene_15krs_A118',
    sceneName_future: 'scene_15krs_A118_future',
    name: 'A118',
    label: 'A118',
    lookAt: '-20.34, 0, 120',
    face: 'north',

    relatedApartments: {
      2: 'A001',
      3: 'A010',
      4: 'A019',
      5: 'A028',
      6: 'A037',
      7: 'A046',
      8: 'A055',
      9: 'A064',
      10: 'A073',
      11: 'A082',
      12: 'A091',
      13: 'A100',
      14: 'A109',
      16: 'A126',
      17: 'talokerho2',
    },
  },
  16: {
    floor: 16,
    building: 'A',
    apartmentNumber: 'A132',
    sceneName: 'scene_16krs_A132',
    sceneName_future: 'scene_16krs_A132_future',
    name: 'A132',
    label: 'A132',
    lookAt: '161.30, 0, 120',
    face: 'south',

    relatedApartments: {
      2: 'A008',
      3: 'A017',
      4: 'A026',
      5: 'A035',
      6: 'A044',
      7: 'A053',
      8: 'A062',
      9: 'A071',
      10: 'A080',
      11: 'A089',
      12: 'A098',
      13: 'A107',
      14: 'A116',
      15: 'A124',
      17: 'talokerho2',
    },
  },
  17: {
    floor: 17,
    building: 'A',
    apartmentNumber: 'talokerho2',
    sceneName: 'scene_17krs_talokerho2',
    sceneName_future: 'scene_17krs_talokerho2_future',
    name: 'talokerho2',
    label: 'talokerho',
    lookAt: '161.30, 0, 120',
    face: 'south',

    relatedApartments: {
      2: 'A009',
      3: 'A018',
      4: 'A027',
      5: 'A036',
      6: 'A045',
      7: 'A054',
      8: 'A063',
      9: 'A072',
      10: 'A081',
      11: 'A090',
      12: 'A099',
      13: 'A108',
      14: 'A117',
      15: 'A125',
      16: 'A133',
    },
  },
}
